module.exports = __webpack_public_path__ + "bf23347e596d0f27796120f5c62cd785.png";